import { Grid, Typography } from '@mui/material';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import ControlledRadioButton from 'src/shared/components/form/controlledRadioButton';

const SendingOrderCustomerForm = () => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant='body2'>
          Efter mottagen beställning skapas fakturamallarav oss på Föreningssupport för er att redigera, till exempel Medlemsavisering 2020. Mallarna
          finns sedan för redigering i fakturamodulen under Arkiv - Mallhantering och ligger till grund för fakturans utseende. Textinnehållet i
          mallarna uppdateras av er och godkänns via rutan Godkänn och lås mallen.
        </Typography>
      </Grid>
      <Grid item xs={12} md={12}>
        <ControlledTextField name='customer' label='Kundnamn, förening eller förbund' />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledTextField name='createdByName' required label='Beställare, ditt namn' />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledTextField name='createdByEmail' required label='Beställare, din e-post' />
      </Grid>
      <Grid item xs={12}>
        <ControlledRadioButton
          name='color'
          defaultValue='true'
          required
          label='Färg eller svartvit tryck?'
          items={[
            {
              value: 'false',
              label: 'Svartvitt',
            },
            {
              value: 'true',
              label: 'Färg',
            },
          ]}
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField name='message' defaultValue='' fullWidth multiline rows={3} label='Övrigt önskemål eller meddelande till oss' />
      </Grid>
    </>
  );
};

export default SendingOrderCustomerForm;
